export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--5-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--5-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--5-3!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Register.vue?vue&type=style&index=0&id=1b1b2506&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/core/Register.vue?vue&type=style&index=0&id=1b1b2506&scoped=true&lang=css&
// module id = K3z2
// module chunks = 1